module.exports = __webpack_public_path__ + "img/democracia-directa.a2dcff65.png";